import { CbInfo } from '@/types/api/v1/CBInfoResponse';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';
export type CBInfoStateType = {
  // CB情報照会
  resultCode: string;
  cbInfos: CbInfo[];
};
export const CBInfoState = atom<CBInfoStateType>({
  key: 'ChashBackInfoState',
  default: {
    // CB情報照会
    resultCode: '',
    cbInfos: []
  },
  effects_UNSTABLE: [persistAtom]
});
export default CBInfoState;